<template>
  <div>
    <header-yjj></header-yjj>
    <header-img-yjj></header-img-yjj>
    <div class="container">
      <p class="nav">当前位置：首页——馆藏文物</p>
      <div class="content">
        <div class="leftNav">
          <h2>栏目导航</h2>
          <div>
            <ul>
              <router-link to="" v-for="item in navList" :key="item.index">
                <li :class="{active:activeFlag == item.flag}" @click="navCur(item.flag)">
                  <h4>{{ item.name }}</h4>
                  <p style="font-size: 14px;">{{ item.des}}</p>
                </li>
              </router-link>
            </ul>
          </div>
        </div>
        <div class="rightCol">
          <div class="rightCol-c">
            <h2>
              <span>馆藏文物</span>
            </h2>
            <div class="wrap" >
              <div class="item" v-for="item in displayList" :key="item.index">
                <router-link :to="{path:'culcont/'+item.id,params:{nav:'wenwu'}}">
                  <img :src="item.imgsrc" style="width: 100%">
                  <p>{{ item.title }}</p>
                </router-link>
              </div>
            </div>
            <div v-if="zhengji==true">
              <div v-for="item in articleData" :key="item.index">
                <h2 style="text-align: center">{{ item.title }}</h2>
                <div class="contentHtml" style="text-align: justify;margin-top: 20px" v-html="item.content">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  底部模板  -->
    <footer-yjj></footer-yjj>
  </div>
</template>

<script>
import HeaderYjj from "@/components/yjj/HeaderYjj";
import FooterYjj from "@/components/yjj/FooterYjj";
import HeaderImgYjj from "@/components/yjj/HeaderImgYjj";
import {request} from "@/request/request";

export default {
  name: "CulturalListYjj",
  components:{
    HeaderYjj,
    FooterYjj,
    HeaderImgYjj
  },
  data(){
    return{
      navList:[
        {id:1,name:'精品文物',flag:1},
        // {id:2,name:'国防教育',flag:2},
        {id:3,name:'文物征集',flag:3},
      ],
      activeFlag:1,
      displayList:[],
      restfulUrl:'cultural',
      zhengji:false,
      articleData:[]
    }
  },
  methods:{
    navCur(data){
      this.activeFlag = data;
      this.getListByColumn(data);
      if(data == 3){
        this.getOneByID("1680465689259765860");
        this.zhengji = true;
      }
      else{
        this.zhengji = false;
      }
    },
    getListByColumn(column){
      request({
        method:'POST',
        url:this.restfulUrl+'/getcolumn',
        data:{columnId:column}
      }).then(res =>{
        this.displayList = res.data;
      },err=>{
        console.log(err)
      })
    },
    getOneByID:function(uid){
      request({
        method:'GET',
        url:'articles/'+uid,
      }).then(res =>{
          this.articleData = []
          this.articleData.push(res.data)
      },err=>{
        console.log(err)
      })

    }
  },
  updated(){
    // if(this.$route.params.nav=='wenwu'){
    //   this.activeFlag = 3;
    //   this.zhengji = true;
    // }
  },
  mounted() {

    this.getListByColumn(1);

  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }

}
</script>

<style scoped>




.container{
  width:70%;
  margin: 0 auto;
  padding:10px 0;
}
.active{
  color:#9E1A28;
  font-weight: bold;
}
.nav{
  text-align: left;
}
.content{
  display: flex;
  margin-top: 20px;
}
.content .leftNav{
  flex:1
}
.leftNav h2{
  color: white;
  height: 60px;
  line-height: 60px;
  background: #9E1A28;
}
.leftNav div{
  margin-top: 10px;
  border: 1px solid silver;
}
.leftNav div{
  padding-bottom: 20px;
}
.leftNav div ul{
  padding:0 20px;
}
.leftNav div ul li {

  padding: 15px 0;
  line-height: 25px;
  border-bottom: 1px silver dashed;
}

.leftNav div ul a{
  color: black;
  text-decoration: none;
}
.rightCol{
  flex: 4;

}
.rightCol-c{
  padding:10px 0 0 60px;
}
.rightCol-c h2{
  padding-bottom: 10px;
  border-bottom: 1px solid silver;
  text-align: left;
}
.rightCol-c h2 span{
  color: #9E1A28;
  padding-bottom: 6px;
  border-bottom: 5px solid #9E1A28;
}
.wrap{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding:20px 0;
}
.item {
  margin: 0 10px 20px 0;
  width: calc((100% - 20px) / 3);
  min-width: calc((100% - 20px) / 3);
  max-width: calc((100% - 20px) / 3);
}
.item a{
  color: black;
  text-decoration: none;
}
.item:nth-child(3n) {
  margin-right: 0
}
.item img{
  height: 240px;
}
</style>
